/*
 * Thanks: Jenny Beelens (http://www.professionaltranslation.com)
 */
t_jp.l = {
    'Close without saving?': 'Schließen ohne Speichern?',
    'You have made a change to the translation. Are you sure you want to discard it?': 'Sie haben die Übersetzung bearbeitet. Sind Sie sicher, dass Sie abbrechen wollen?',
    'History': 'Verlauf',
    'Loading...': 'Laden...',
    'Translated': 'Übersetzt',
    'By': 'von',
    'At': 'über',
    'google': 'Google',
    'bing': 'Bing',
    'apertium': 'Apertium',
    'manual translation': 'manuelle Übersetzung',
    'bing suggest': 'Bing Suggest',
    'google suggest': 'Google Suggest',
    'apertium suggest': 'Apertium Suggest',
    'Edit Translation': 'Übersetzung bearbeiten',
    'Original text': 'Originaltext',
    'read alternate translations': 'alternative Übersetzung lesen',
    'previous translation': 'Vorherige',
    'find on page': 'Auf Seite suchen',
    'next translation': 'Nächste',
    'Translate to': 'Übersetzen nach',
    'view translation log': 'Übersetzungsprotokoll anzeigen',
    'virtual keyboard': 'virtuelle Tastatur',
    'approve translation': 'Übersetzung genehmigen',
    'delete': 'Löschen',
    'Discard': 'Verwerfen',
    'Cancel': 'Abbrechen'
};